module.exports = __webpack_public_path__ + "static/img/cdb3.a0ae55af.png";